import { useState } from 'react';
import Cookies from 'js-cookie';
import { AuthProviderProps, AuthStateType } from '@/types/types';
import AuthContext from './AuthCtx';
import fetchToken from '@/util/FetchToken';
import { redirect } from 'react-router-dom';
import { queryClient } from '@/util/queryClient';

export const AuthProvider = ({ children }: AuthProviderProps) => {
  const [authState, setAuthState] = useState<AuthStateType>(() => {
    const authStateCookie = Cookies.get('authState');
    return authStateCookie ? JSON.parse(authStateCookie) : null;
  });

  const login = async (email: string, password: string) => {
    const data = await fetchToken(email, password);

    const newState = {
      user: data.user,
      token: data.token,
      tokenExpiration: data.expiredAt,
      avatarUrl: data.user.avatarUrl,
    };

    Cookies.set('authState', JSON.stringify(newState))
    setAuthState(newState);

    Cookies.set(
      'authRefreshToken',
      JSON.stringify({
        token: data.refreshToken,
        tokenExpiration: data.refreshTokenExpiration,
      })
    );

    // queryClient.clear();
    await queryClient.removeQueries();
  };

  const logout = (callback?: () => void) => {
    Cookies.remove('authState');
    Cookies.remove('authRefreshToken');
    setAuthState(null);
    queryClient.removeQueries()
    if (callback) callback();
    redirect('/');
  };

  return (
    <AuthContext.Provider value={{ setAuthState, authState, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};
